import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Report, RowActions } from '../../../../admin/report/report';
import constantQassatlyRepaymentStatus from '../../../../../shared/qassatlyRepaymentStatus';
import { CallingQassatlyRepaymentReportService } from '../../services/calling-qassatly-repayment.service';
import { QassatlyRepaymentReportService } from '../../services/qassatly-repayment-report.service';
import { LanguageService } from '../../../../../shared/services/language.service';

@Component({
  selector: 'app-qassatly-repayments',
  templateUrl: './qassatly-repayments.component.html',
  styleUrls: ['./qassatly-repayments.component.scss']
})
export class QassatlyRepaymentsComponent implements OnInit {
  isUpdated: boolean = true;
  filterField: any[] = [];
  tableColumns: string[] = [
    'merchantName',
    'amount',
    'lateFees',
    'mobile',
    'status',
    'dueDateFormated'
  ];
  displayTableColumns = {
    'merchantName': 'merchant Name',
    'amount': 'Amount',
    'lateFees': 'Late Fees',
    'mobile': 'Mobile',
    'status': 'Status',
    'dueDateFormated': 'DueDate',
  };
  totalNumberOfRecords: number = 0;
  qassatlyRepaymentReportData: any[] = [];
  reportName: string = '';

  emptyDataMessage = "Press To show Qassatly Repayment Report";
  rowActions: RowActions[] = [
    {
      actionName: "View",
      actionType: "Button",
      actionClass: "btn-primary"
    }
  ];
  requestBody: Report = {};
  loading: boolean = false;

  constructor(
    public qassatlyRepaymentReportService: QassatlyRepaymentReportService,
    public callingQassatlyRepaymentReportService: CallingQassatlyRepaymentReportService,
    private translate: TranslateService,
    private languageService: LanguageService,
  ) { }

  async ngOnInit() {
    if (localStorage.getItem("language")) {
      if (localStorage.getItem("language") === "ar") {
        this.loadArContent();
      } else if (localStorage.getItem("language") === "en") {
        this.loadEnContent();
      }
    } else {
      this.loadEnContent();
    }
    this.languageService.languageUpdated.subscribe((lang: string) => {
      if (lang === "ar") {
        this.loadArContent();
      } else if (lang === "en") {
        this.loadEnContent();
      }
    });
    this.qassatlyRepaymentReportService.activateLoader();
    this.emptyDataMessage
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10,
    };
    this.updateTable();
  }

  loadArContent() {
    this.translate.use('ar');
    this.reportName = 'تقرير السداد قسطلى';
    this.displayTableColumns = {
      'merchantName': 'إسم التاجر',
      'amount': 'المبلغ',
      'lateFees': 'الرسوم المتأخرة',
      'mobile': 'رقم الموبايل',
      'status': 'الحالة',
      'dueDateFormated': 'تاريخ الاستحقاق',
    };

    this.filterField = [
      {
        filterFieldName: "status",
        filterDisplayName: "الحالة",
        defaultValue: "",
        filterOptions: [
          { key: "إظهار الكل", value: null },
          { key: 'جاهز للدفع', value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Ready_To_Pay },
          { key: 'القادمة', value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Upcoming },
          { key: 'تم الدفع', value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Paid },
          { key: 'الرسوم المتأخرة', value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Paid_Late },
        ]
      }
    ];
  }

  loadEnContent() {
    this.translate.use('en');
    this.reportName = 'Qassatly Repayment Report';
    this.displayTableColumns = {
      'merchantName': 'merchant Name',
      'amount': 'Amount',
      'lateFees': 'Late Fees',
      'mobile': 'Mobile',
      'status': 'Status',
      'dueDateFormated': 'DueDate',
    };
    this.filterField = [
      {
        filterFieldName: "status",
        filterDisplayName: "Status",
        defaultValue: "",
        filterOptions: [
          { key: "Show All", value: null },
          { key: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.name.Ready_To_Pay, value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Ready_To_Pay },
          { key: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.name.Upcoming, value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Upcoming },
          { key: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.name.Paid, value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Paid },
          { key: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.name.Paid_Late, value: constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Paid_Late },
        ]
      }
    ];
  }


  async filter($event: any) {
    if ($event && Object.keys($event).length) {
      this.requestBody.filterOptions = $event;
    } else {
      this.requestBody.filterOptions = {};
    }
    this.requestBody.paginationOptions = {
      start: 0,
      limit: 10
    };
    this.updateTable();
    this.qassatlyRepaymentReportService.loader().subscribe((val: any) => (this.loading = val));
  }

  async showData() {
    await this.callingQassatlyRepaymentReportService.make();
    await this.updateTable();
    this.qassatlyRepaymentReportService.loader().subscribe((val: any) => (this.loading = val));
    this.isUpdated = false
  }

  async paginate($event: any) {
    this.requestBody.paginationOptions = {
      start: $event.pageIndex * $event.pageSize,
      limit: $event.pageSize
    };
    this.updateTable();
  }

  async searchChance($event: any) {
    if ($event) {
      this.requestBody.searchOptions = {
        searchKey: $event
      };
    } else {
      this.requestBody.searchOptions = undefined;
      this.qassatlyRepaymentReportService.loader().subscribe((val: any) => (this.loading = val));
    }
    await this.updateTable();
  }

  async sortChange(event: any) {
    if (event.direction === '') {
      this.requestBody.sortOptions = {};
    } else {
      this.requestBody.sortOptions = {
        [`${event.active}`]: event.direction
      };
    }
    await this.updateTable();
    this.qassatlyRepaymentReportService.loader().subscribe((val: any) => (this.loading = val));
  }

  async updateTable() {
    this.qassatlyRepaymentReportService.activateLoader();
    this.qassatlyRepaymentReportService.setParams(this.requestBody);
    const report = await this.qassatlyRepaymentReportService.make();
    this.qassatlyRepaymentReportData = report.result.map((value: any) => {
      if (value.status == constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Ready_To_Pay) {
        value.status = "Ready To Pay";
      }
      if (value.status == constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Paid_Late) {
        value.status = "Paid Late";
      }
      if (value.status == constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Upcoming) {
        value.status = "Upcoming";
      }
      if (value.status == constantQassatlyRepaymentStatus.constantQassatlyRepaymentStatus.value.Paid) {
        value.status = "Paid";
      }
      return value;
    });;

    if (this.qassatlyRepaymentReportData.length == 0) {
      this.callingQassatlyRepaymentReportService.make();
    }
    this.totalNumberOfRecords = report.totalNumberOfRows;
    this.emptyDataMessage = '';

  }
}
